import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import React from "react";

import { colors } from "../values/colors";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";

const DisplayDetailsCard = (props) => {
  const {
    heading,
    subtitle,
    location,
    enableShadow,
    customStyles,
    drawHeaderLine,
    item,
    onClick,
    imageLogo,
    displayRightIcon,
  } = props;

  return (
    <Card
      variant="outlined"
      sx={[
        {
          boxShadow: enableShadow ? "0px 5px 5px rgba(0, 0, 0, 0.2)" : null,
          m: 2,
          cursor: "pointer",
          borderRadius: "5px",
        },
        customStyles,
      ]}
      onClick={() => onClick(item)}
    >
      <CardContent style={{ paddingBottom: "0px", padding: "10px" }}>
        <Stack
          direction={"row"}
          sx={{
            borderColor: "rgba(0, 0, 0, 0.19)",
          }}
        >
          <Stack display={"flex"} style={{ width: "20%" }}>
            <img src={imageLogo} style={{ width: "100%", height: "100%" }} />
          </Stack>
          <Stack display={"flex"} flex={1} sx={{ paddingX: "20px" }}>
            <Stack sx={{ flex: 1, justifyContent: "center" }}>
              <Typography
                variant="h5"
                sx={{ color: colors.black, fontSize: "17px" }}
              >
                {heading}
              </Typography>
              {subtitle && (
                <Typography sx={{ fontWeight: 400 }} variant="subtitle1">
                  {subtitle}
                </Typography>
              )}
              {location && (
                <Stack
                  display={"flex"}
                  flexDirection={"row"}
                  sx={{
                    alignItems: "center",
                    mt: 1,
                  }}
                >
                  <Stack sx={{ mr: 0.5 }}>
                    <PlaceOutlinedIcon sx={{ fontSize: "1rem" }} />
                  </Stack>
                  <Stack>
                    <Typography sx={{ fontWeight: 400 }} variant="subtitle1">
                      {location}
                    </Typography>
                  </Stack>
                </Stack>
              )}
            </Stack>
          </Stack>
          {displayRightIcon && (
            <Stack
              display={"flex"}
              style={{ justifyContent: "center", alignItems: "center" }}
            >
              <ArrowForwardIosIcon sx={{ fontSize: "1.2rem" }} />
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default DisplayDetailsCard;
